import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { showSnoozeBlocker } from '../../../../../base/effects/showSnoozeBlocker';

export const checkTabBrandingPermission = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(showSnoozeBlocker({
            allow: 'allowBranding'
        }));
    };
    return action;
};
